export const Footer = () => {
  return (
    <footer className="bg-primary/80 backdrop-blur-lg border-t border-white/10 py-2">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-white/80 text-xs">
          <div>
            <h3 className="font-semibold mb-3">Políticas</h3>
            <ul className="space-y-2">
              <li><a href="/privacy-policy" className="hover:text-secondary">Política de Privacidade</a></li>
              <li><a href="/terms-of-use" className="hover:text-secondary">Termos de Uso</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-3">Contato</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://wa.me/556292060092" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-secondary"
                >
                  Fale Conosco
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs leading-relaxed max-w-md">
              A AutoMate Labbs segue rigorosamente todas as normas nacionais e internacionais de privacidade e proteção de dados, incluindo LGPD e GDPR. 
              Nosso compromisso é garantir a segurança e confidencialidade das informações de nossos clientes em todas as nossas operações e serviços.
            </p>
            <p className="text-xs mt-4">
              © 2024 AutoMate Labbs. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};